import {Fragment, useRef, useState} from "react"
import useApi from "../hooks/useApi"
import useModal from "../hooks/useModal"
import useDialog from "../hooks/useDialog"
import useToast from "../hooks/useToast"
import useRefresh from "../hooks/useRefresh"
import ModalHeader from "../components/ModalHeader"
import ModalContent from "../components/ModalContent"
import ModalTitle from "../components/ModalTitle"
import ButtonPrimary from "../commons/ButtonPrimary"
import ButtonSecondary from "../commons/ButtonSecondary"
import Dropdown from "../commons/Dropdown"
import Uploader from "../commons/Uploader"

const liquidationTypeOptions=[
    {label:"PayFun crédito",value:"payFunCreditCard"},
    {label:"PayFun débito",value:"payFunDebitCard"}
]

export default function CreateConciliation(){

    const {manageModal}=useModal()
    const {changeDialog}=useDialog()
    const {changeToast}=useToast()
    const {refresh}=useRefresh()
    const requestApi=useApi()

    const fileInput=useRef()
    const [processing,setProcessing]=useState(false)
    const [type,setType]=useState("")

    const uploadConciliation=()=>{
        if(processing){
            return
        }

        if(!type){
            changeToast("error","Seleccioná el tipo de archivo")
            return
        }

        if(!fileInput.current || !fileInput.current.files || fileInput.current.files.length===0){
            fileInput.current.click()
            return
        }

        const file=fileInput.current.files[0]
        if(!file.name || !file.name.toLowerCase().endsWith(".xlsx")){
            changeToast("file_not_allow","")
            return
        }

        setProcessing(true)

        requestApi("conciliation/create",{
            upload:file,
            file:file,
            type:type
        }).then(data=>{
            if(data.status==="success"){
                refresh(["list"],"")
                setProcessing(false)
                manageModal("hide")
            }else{
                setProcessing(false)
                changeDialog("generic_error","","")
            }
        }).catch(()=>{
            setProcessing(false)
            changeDialog("generic_error","","")
        })
    }

    return(
        <Fragment>
            <ModalHeader />
            <ModalContent>
                <div className="modal-form">
                    <ModalTitle title="Nueva conciliacion" />
                    {processing ? (
                        <div className="conciliation-processing noselect">
                            <div className="conciliation-processing-spinner"></div>
                            <div className="conciliation-processing-text">Conciliando transacciones</div>
                        </div>
                    ) : (
                        <Fragment>
                            <div className="modal-explanation modal-explanation-center">
                                Subi el archivo de rendicion para procesar la conciliacion.
                            </div>
                            <div className="form-block">
                                <Dropdown options={liquidationTypeOptions} placeholder="Tipo de conciliación" multiple={false} searchable={false} val={type} setVal={setType} />
                            </div>
                            <Uploader ref={fileInput} label="Subir archivo de rendición" note="Formato permitido: Excel (.xlsx)" multiple={false} restrict="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" action="" />
                            <div className="conciliation-modal-actions noselect">
                                <ButtonSecondary label="Cancelar" clickEvent={()=>{manageModal("hide")}} />
                                <ButtonPrimary label="Conciliar" clickEvent={uploadConciliation} />
                            </div>
                        </Fragment>
                    )}
                </div>
            </ModalContent>
        </Fragment>
    )

}
